import CreatedCredentials from "./created-credentials";
import InputField from "@components/fields/input-field";
import LoadingButton from "@components/ui-components/loading-button";
import useOpsAccount from "../hooks/use-ops-account";

// The whole ops step: one form, one call. Deliberately not a list — POST
// /ops/v1 is the only ops endpoint this console speaks to.
const OpsAccountPanel = () => {
    const { methods, loading, submit, created, dismissCreated } = useOpsAccount();
    const { control, formState: { errors } } = methods;

    return (
        <div className="space-y-4">
            <div>
                <h2 className="text-lg font-semibold text-gray-900">Create an ops account</h2>
                <p className="text-sm text-muted">
                    <code className="rounded bg-light px-1.5 py-0.5 text-xs text-gray-700">POST /api/ops/v1</code>
                    {" — the account that signs into the ops workspace."}
                </p>
            </div>

            <form
                className="max-w-xl rounded-xl border border-gray-200 bg-white p-5 shadow-sm"
                onSubmit={(event) => {
                    event.preventDefault();
                    submit();
                }}>
                <InputField control={control} errors={errors} name="name" id="ops-name" label="Name" placeholder="Rana" required />
                <InputField control={control} errors={errors} name="email" id="ops-email" label="Email" placeholder="bharat28rana@gmail.com" required />
                <InputField control={control} errors={errors} name="password" id="ops-password" type="password" label="Password" required />
                <div className="mt-2 flex justify-end">
                    <LoadingButton type="submit" text="Create account" loading={loading} loadingText="Creating…" />
                </div>
            </form>

            <CreatedCredentials rows={created} title="Created this session" onDismiss={dismissCreated} />
        </div>
    );
};

export default OpsAccountPanel;
